import React, { useEffect } from "react";

export function Toast({ message, type = "success", onDismiss }) {
  const colors = {
    success: "bg-green-50 border-green-200 text-green-700",
    error: "bg-red-50 border-red-200 text-red-700",
    warning: "bg-amber-50 border-amber-200 text-amber-800",
    info: "bg-blue-50 border-blue-200 text-blue-700",
  };
  const icon = type === "error" ? "error" : type === "warning" ? "warning" : type === "info" ? "info" : "check_circle";

  return (
    <div className={`fixed bottom-5 right-5 flex items-center gap-3 px-4 py-3 rounded-xl border shadow-lg z-[80] max-w-[360px] ${colors[type] || colors.success}`}>
      <span className="material-symbols-outlined text-[18px] flex-shrink-0">{icon}</span>
      <p className="text-sm font-medium flex-1">{message}</p>
      <button onClick={onDismiss} className="opacity-60 hover:opacity-100">
        <span className="material-symbols-outlined text-[16px]">close</span>
      </button>
    </div>
  );
}

export function ConfirmModal({
  open,
  title,
  message,
  confirmText = "Ya",
  cancelText = "Batal",
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const fn = (e) => {
      if (e.key === "Escape" && !loading) onCancel?.();
    };
    document.addEventListener("keydown", fn);
    return () => document.removeEventListener("keydown", fn);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[75] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl border border-gray-100 overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center gap-3">
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${danger ? "bg-red-50 text-red-600" : "bg-[#10a37f]/10 text-[#10a37f]"}`}>
            <span className="material-symbols-outlined text-[20px]">{danger ? "delete" : "archive"}</span>
          </div>
          <h3 className="text-base font-bold text-gray-900">{title}</h3>
        </div>
        <div className="px-5 py-4">
          <p className="text-sm leading-relaxed text-gray-600">{message}</p>
        </div>
        <div className="px-5 py-4 bg-gray-50 flex justify-end gap-2">
          <button
            type="button"
            disabled={loading}
            onClick={onCancel}
            className="px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-600 hover:bg-gray-100 disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className={`px-4 py-2 rounded-xl text-sm font-semibold text-white disabled:opacity-50 ${danger ? "bg-red-600 hover:bg-red-700" : "bg-[#202123] hover:bg-[#10a37f]"}`}
          >
            {loading ? "Memproses..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
